<forge-checkbox #input [formControl]="formControl" [id]="controlName">
  <label [for]="controlName" class="forge-typography--body1">
    <span class="label-truncate">{{label}}</span>
  </label>
  @if (showTooltip) {
    <forge-tooltip>{{tooltip}}</forge-tooltip>
  }
</forge-checkbox>
